import { render, staticRenderFns } from "./LocaleSwither.vue?vue&type=template&id=6d376c70&scoped=true"
import script from "./LocaleSwither.vue?vue&type=script&lang=js"
export * from "./LocaleSwither.vue?vue&type=script&lang=js"
import style0 from "./LocaleSwither.vue?vue&type=style&index=0&id=6d376c70&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d376c70",
  null
  
)

export default component.exports